import { Box, Chip, Typography } from '@material-ui/core'
import Loading from '../../Loading'
import Scrollable from '../../Scrollable'
import { useConsolidationStyles } from './styles'
import { useConsolidationTranslation } from './translation'
import { useConsolidation } from './useConsolidation'

export const Consolidation = () => {
  const { consolidationCollection, isConsolidationLoaded, cashbackSymbol } =
    useConsolidation()
  const consolidationClasses = useConsolidationStyles()
  const consolidationTranslation = useConsolidationTranslation()

  return (
    <Box className={consolidationClasses.root}>
      <Typography className={consolidationClasses.title}>
        {consolidationTranslation.consolidation}
      </Typography>
      {!isConsolidationLoaded && <Loading />}
      {isConsolidationLoaded && (
        <Scrollable
          itemWidth={250}
          className={consolidationClasses.listContainer}
        >
          {consolidationCollection.map(
            ({ value, description, key, model, type }) => {
              return (
                <Box
                  key={key}
                  className={consolidationClasses.consolidationContainer}
                >
                  <Box className={consolidationClasses.statusContainer}>
                    <Typography className={consolidationClasses.amount}>
                      <span className={consolidationClasses.symbol}>
                        {cashbackSymbol}
                      </span>{' '}
                      {value}
                    </Typography>

                    <Typography className={consolidationClasses.status}>
                      {type}
                    </Typography>
                  </Box>

                  <Typography
                    className={consolidationClasses.consolidationLabel}
                  >
                    {description}
                  </Typography>

                  <Chip label={model} className={consolidationClasses.chip} />
                </Box>
              )
            },
          )}
        </Scrollable>
      )}
    </Box>
  )
}
